export const ONBOARDING_SECTIONS = [
  '',
  'form',
  'status',
];

export const DEFAULT_ONBOARDING_SECTION = ONBOARDING_SECTIONS[0];
